import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';

export default class OutLink extends Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
    isExternal: PropTypes.bool
  };

  render() {
    const {
      to: href,
      className,
      children,
      isExternal = false
    } = this.props;

    if (isExternal) {
      return <a {...{className, href}} target="_blank">{children}</a>;
    }
    else {
      // Regex matches any protocol and domain, and the rest of the path
      const [, protocol = false, path] = href.match(/^((?:https?:)?\/\/[^/]+)?(.*)/i);
      const to = (protocol === false) ? href : path;

      return <Link {...{className, to}}>{children}</Link>
    }
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/OutLink.js